<template>
  <el-table
    :data="carriersList"
    stripe
    size="small"
  >
    <el-table-column type="expand">
      <template slot-scope="props">
        <CarrierPeek :carrier="props.row" />
      </template>
    </el-table-column>
    <el-table-column
      prop="name"
      label="Name"
      sortable
      width="400px"
    >
      <template slot-scope="scope">
        <div class="carrier-name">
          <router-link :to="{ name:'manage-carriers-carrier', params: { carrierId: scope.row.id } }">
            {{ scope.row.name }}
          </router-link>
          <img
            v-if="scope.row.logo_url"
            :src="scope.row.logo_url"
            class="carrier-logo"
          >
        </div>
      </template>
    </el-table-column>
    <el-table-column
      label="Address"
      width="600px"
      :formatter="row => formatAddress(row)"
    />
    <el-table-column
      prop="enabled"
      label="Status"
      sortable
    >
      <template slot-scope="props">
        <el-tag
          :type="getStatus(props.row.enabled)"
          size="mini"
        >
          {{ props.row.enabled ? "enabled" : "disabled" | titleize }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column
      label="Carrier Group"
      :formatter="row => $_.get(row, 'carrier_group.name', '-')"
    />
    <el-table-column
      label="Tier"
    >
      <el-tag
        v-if="props.row.carrier_tier"
        slot-scope="props"
        :type="getTierColor(props.row.carrier_tier)"
        size="mini"
      >
        {{ props.row.carrier_tier > 0 ? 'Tier ' + props.row.carrier_tier : '-' }}
      </el-tag>
    </el-table-column>
    <el-table-column
      v-if="canDelete"
      label="Action"
      align="right"
    >
      <template slot-scope="props">
        <el-button
          v-if="canDelete"
          size="mini"
          type="danger"
          @click.native="deleteCarrier(props.row)"
        >
          Delete
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import CarrierPeek from '@/components/Application/Manage/Carriers/Peek'
import { DELETE } from '@/plugins/user'
export default {
  components: {
    CarrierPeek
  },
  props: {
    carriersList: {
      type: Array,
      required: true
    }
  },
  computed: {
    canDelete () {
      return this.$user.can(DELETE, this.$sdk.carrier)
    }
  },
  methods: {
    formatAddress (carrier) {
      const addresses = []
      if (this.$_.get(carrier, 'address')) {
        addresses.push(this.$_.get(carrier, 'address'))
      }
      if (this.$_.get(carrier, 'town')) {
        addresses.push(this.$_.get(carrier, 'town'))
      }
      if (this.$_.get(carrier, 'state')) {
        addresses.push(this.$_.get(carrier, 'state'))
      }
      if (this.$_.get(carrier, 'postcode')) {
        addresses.push(this.$_.get(carrier, 'postcode'))
      }
      const addressStr = addresses.filter(a => a !== '-').join(', ')
      return addressStr !== '0' ? addressStr : '-'
    },
    deleteCarrier (carrier) {
      this.$emit('deleteCarrier', carrier)
    },
    getStatus (status) {
      return status ? 'success' : 'warning'
    },
    getTierColor (tier) {
      switch (tier) {
        case 1:
          return 'success'
        case 2:
          return 'primary'
        case 3:
          return 'info'
        case 4:
          return 'warning'
        default:
          return 'danger'
      }
    }
  }
}
</script>

<style scoped>
.carrier-name {
  display: flex;
  align-items: center;
}

.carrier-logo {
  display: block;
  width: 40px;
  height: 40px;
  margin-left: 5px;
  object-fit: contain;
}
</style>
